<template>
    <div class="gap-sm flex w-full flex-col" :class="props.class">
        <div v-if="company" class="gap-xs flex items-center">
            <AvatarArea :size="'x-small'" :first-name="company" />
            {{ company }}
        </div>
        <TagComponent
            v-if="level"
            :value="level_strings[level]"
            :variant="level === 3 ? 'gold' : level === 2 ? 'silver' : level === 1 ? 'bronze' : 'default'"
            class-name="rounded-xsm w-fit capitalize"
        />
    </div>
</template>

<script setup lang="ts">
import AvatarArea from '@/components/avatar-area.vue';
import TagComponent from '@/components/ui/tag/TagComponent.vue';

const props = defineProps({
    company: String,
    level: Number,
    class: { type: String, required: false },
});

const level_strings = ['', 'Bronze', 'Silver', 'Gold'];
</script>
